import { Box } from "@mantine/core";
import { forwardRef, ReactNode, type JSX } from "react";
import classes from "./styles.module.scss";
interface CircleContainerProps extends React.ComponentPropsWithoutRef<"div"> {
  children: ReactNode;
  onClick?: () => void;
}

const CircleContainer = forwardRef<HTMLDivElement, CircleContainerProps>(
  ({ children, onClick }: CircleContainerProps, ref) => (
    <Box ref={ref} onClick={onClick} className={classes.container}>
      {children}
    </Box>
  )
);

export default CircleContainer;
